var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { notificationSvg } from '../../helpers/elements.js';
import { classMap } from 'lit/directives/class-map.js';
import { isEmailValid } from '../../helpers/string.js';
import { ifDefined } from 'lit/directives/if-defined.js';
let ElementInput = class ElementInput extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.disabled = false;
        this.textArea = false;
        this.bigTextArea = true;
        this.availableHeight = false;
        this.required = false;
        this.value = '';
        this.useCloseIcon = false;
        this.error = false;
    }
    validate() {
        this.error = this.required && !this.value?.length;
        if (!this.error && this.type === 'email') {
            this.error = !isEmailValid(this.value);
        }
    }
    renderInputElement() {
        return html ` <input
      .disabled=${this.disabled}
      type="${this.type}"
      .value="${this.value}"
      maxlength="${ifDefined(this.maxLength)}"
      class="${classMap({
            error: this.error,
            'date-input': this.type === 'date',
            'pr-[20px]': !this.useCloseIcon,
            'pr-[40px] md:pr-[50px]': this.useCloseIcon,
        })} h-[40px] md:h-[56px] w-full flex-auto pl-[20px] py-[17px] outline-none"
      placeholder="${ifDefined(this.placeholder)}"
      @focusin="${() => (this.error = false)}"
      @focusout="${this.validate}"
    />`;
    }
    get textAreaElement() {
        return html ` <textarea
      .disabled=${this.disabled}
      .value="${this.value}"
      class="${classMap({
            error: this.error,
            'h-[120px]': !this.availableHeight && this.bigTextArea,
            'sm:h-[160px]': !this.availableHeight && this.bigTextArea,
            'h-[62px]': !this.availableHeight && !this.bigTextArea,
            'md:h-[86px]': !this.availableHeight && !this.bigTextArea,
        })} w-full flex-auto px-[20px] py-[17px] outline-none"
      placeholder="${ifDefined(this.placeholder)}"
      @focusin="${() => (this.error = false)}"
      @focusout="${this.validate}"
    >
${this.value}</textarea>`;
    }
    render() {
        return html ` <div
      class="body w-full ${classMap({
            'h-full': this.availableHeight,
        })}"
    >
      <div
        .hidden="${!this.label?.length}"
        class="${classMap({
            'text-disabled': this.disabled,
        })} select-none text-ellipsis whitespace-nowrap font-bold"
      >
        <span>${this.label}</span>
        <span .hidden="${!this.required}" class="font-normal"
          >(Mandatory field)</span
        >
      </div>
      <div
        class="flex flex-row-reverse ${classMap({
            'h-full': this.availableHeight,
        })}"
      >
        ${this.textArea ? this.textAreaElement : this.renderInputElement()}
        ${this.error
            ? notificationSvg('h-[24px] w-[24px] fill-danger rotate-180 self-center absolute mr-[12px] md:mr-[20px]')
            : ''}
      </div>
      <div class="pl-[16px] text-danger" .hidden="${!this.error}">
        ${this.errorMessage}
      </div>
    </div>`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String })
], ElementInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: String })
], ElementInput.prototype, "label", void 0);
__decorate([
    property({ type: String })
], ElementInput.prototype, "errorMessage", void 0);
__decorate([
    property({ type: String })
], ElementInput.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "textArea", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "bigTextArea", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "availableHeight", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "required", void 0);
__decorate([
    property({ type: String })
], ElementInput.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], ElementInput.prototype, "useCloseIcon", void 0);
__decorate([
    property({ type: Number })
], ElementInput.prototype, "maxLength", void 0);
__decorate([
    state()
], ElementInput.prototype, "error", void 0);
ElementInput = __decorate([
    customElement('element-input')
], ElementInput);
export { ElementInput };
//# sourceMappingURL=element-input.js.map